module.exports = __webpack_public_path__ + "static/media/warning-icon.cca8e1d1.svg";